/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewZoomyDomainConfidenceMapScore } from './CRSFSecReviewZoomyDomainConfidenceMapScore';
import {
    CRSFSecReviewZoomyDomainConfidenceMapScoreFromJSON,
    CRSFSecReviewZoomyDomainConfidenceMapScoreFromJSONTyped,
    CRSFSecReviewZoomyDomainConfidenceMapScoreToJSON,
} from './CRSFSecReviewZoomyDomainConfidenceMapScore';

/**
 * Model that holds all domain confidence scores done for the expansion domains against a single account domain.
 * @export
 * @interface CRSFSecReviewZoomyAccountDomainConfidenceMap
 */
export interface CRSFSecReviewZoomyAccountDomainConfidenceMap {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewZoomyAccountDomainConfidenceMap
     */
    account_domain: string;
    /**
     * 
     * @type {{ [key: string]: CRSFSecReviewZoomyDomainConfidenceMapScore; }}
     * @memberof CRSFSecReviewZoomyAccountDomainConfidenceMap
     */
    confidence_map: { [key: string]: CRSFSecReviewZoomyDomainConfidenceMapScore; };
}

/**
 * Check if a given object implements the CRSFSecReviewZoomyAccountDomainConfidenceMap interface.
 */
export function instanceOfCRSFSecReviewZoomyAccountDomainConfidenceMap(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "account_domain" in value;
    isInstance = isInstance && "confidence_map" in value;

    return isInstance;
}

export function CRSFSecReviewZoomyAccountDomainConfidenceMapFromJSON(json: any): CRSFSecReviewZoomyAccountDomainConfidenceMap {
    return CRSFSecReviewZoomyAccountDomainConfidenceMapFromJSONTyped(json, false);
}

export function CRSFSecReviewZoomyAccountDomainConfidenceMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewZoomyAccountDomainConfidenceMap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_domain': json['account_domain'],
        'confidence_map': (mapValues(json['confidence_map'], CRSFSecReviewZoomyDomainConfidenceMapScoreFromJSON)),
    };
}

export function CRSFSecReviewZoomyAccountDomainConfidenceMapToJSON(value?: CRSFSecReviewZoomyAccountDomainConfidenceMap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_domain': value.account_domain,
        'confidence_map': (mapValues(value.confidence_map, CRSFSecReviewZoomyDomainConfidenceMapScoreToJSON)),
    };
}

